"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "presenterSettingsSource", {
  enumerable: true,
  get: function get() {
    return _presenterSettingsSource["default"];
  }
});
var _presenterSettingsSource = _interopRequireDefault(require("./presenterSettingsSource"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }